import React from 'react';
import { WorkflowLayout } from 'Components/ComponentLibrary/Organisms/WorkflowLayout/WorkflowLayout';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import { FDContentContainer, FDPrimaryActionButton, FDStack } from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { usePageContentContext } from 'Views/Page/Contexts/PageContentContext';
import { WizardBackButtonRel } from 'Packages/FacetCore/Experimental/RelationshipComponents/WizardBackButtonRel';
import { dataAttrs } from 'Helpers/Testing';

export const AccountOpeningV2BeneficiaryAllocationsStepLayout = () => {
  const { resource, onSubmit, handleChange } = useMetaLayoutContext();
  const { loadPageContentLink } = usePageContentContext();

  return (
    <WorkflowLayout appearance={'elevated'}>
      <FDContentContainer maxWidth="sm">
        <FDStack direction={'column'} spacing={8}>
          <FDStack direction={'column'} spacing={2}>
            <MetaControlField attr={'title'} />
            <MetaControlField attr={'description'} />
            <MetaControlField
              attr={'beneficiaryAllocations'}
              CustomProps={{
                onChange: (updatedResource, resourceIndex) => {
                  resource.attr('beneficiaryAllocations').resources().replaceAtIndex(resourceIndex, updatedResource);
                  handleChange('beneficiaryAllocations', resource.attr('beneficiaryAllocations'));
                },
              }}
            />
          </FDStack>
          <FDStack spacing={2} alignItems={'center'} justifyContent={'center'}>
            <WizardBackButtonRel overrideOnClick={(_, rel) => loadPageContentLink(rel.link('related'))} resource={resource} />
            {resource.meta().canPost() ? (
              <FDPrimaryActionButton
                {...dataAttrs('continue-btn', resource)}
                label={resource.attr('primaryActionLabel')}
                onClick={() => onSubmit()}
              />
            ) : null}
          </FDStack>
        </FDStack>
      </FDContentContainer>
    </WorkflowLayout>
  );
};
